import { render, staticRenderFns } from "./tax-services-icon.vue?vue&type=template&id=62c0a8ad"
import script from "./tax-services-icon.vue?vue&type=script&lang=js"
export * from "./tax-services-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports